import React, { useEffect, useState } from "react";
import reseticon from "assets/icon/Edit-Icons (1).svg";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, ModalFooter } from "reactstrap";
import { ModuleAccess } from "utils/moduleaccess";
import useAxios from "hooks/useAxios";
import CancelIcon from "assets/icon/cancel.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import { cloneDeep } from "lodash";
import { toast } from "react-toastify";
import { dateFormate } from "utils/columns";
import { preconnect } from "react-dom";
import HL7Drawer from "../HL7";
import Drawer from "components/Drawer";
import Hl7Payor from "../HL7Payor";



const hasPermission = (code) => {
  return ModuleAccess("CON", code);
};
let Accumulaterflag = false
let hl7MessageData = [];
let rowFlags = ["hL7PayorFlag", "hL7PatientAndLocationFlag"]
const General = (props) => {
  const API = useAxios();
  const { orgId, SelectedAccumulator, keyname, setLoading,
    loading } = props;
  console.log(SelectedAccumulator, "SelectedAccumulator")
  const [flags, setFlags] = useState([])
  const [rowData, setRowData] = useState({});
  const [tabledata, setTableData] = useState({})
  const [edit, setEdit] = useState(false);
  const [hyperLinkFlag, setyperLinkFlag] = useState(false);
  const [cancel, setCancel] = useState(false)
  const [checkedname, setCheckedname] = useState("")
  const [savedisabled, setSaveDisabled] = useState(false)
  //const[isOpenFlag,setIsOpenFlag]=useState(false)
  const [message, setMessage] = useState('')
  const [opendrawer, setOpenDrawer] = useState(false)
  const [hl7Payordrawer, setHl7Payordrawer] = useState(false);
  const [isCheck, setIsCheck] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [hl7PayorhyperLinkFlag, setHl7PayorHyperLinkFlag] = useState(false);

  // let initialStates = {
  //     currentPage: 1,
  //     pageSize: 100,
  //     order: 'desc',
  //     orderBy: 'modifiedDate',
  //     Filters: [],
  //     AccumulatorID: SelectedAccumulator
  //   }

  useEffect(() => {
    handelGeneralList();
  }, [orgId, SelectedAccumulator, keyname,]);

  const handelGeneralList = async () => {
 if(keyname==="general"){
    setLoading(true)
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/Configuration/Generalist/${SelectedAccumulator}`,
        {
          hasDefaultURL: true,
        }
      );
      debugger;
      console.log(data, "general");
      if (data) {

        console.log(data, "data");
        const flagsvalue = []
        setTableData(data)
        const flagProperties = [
          { name: "GCN Automapping ", prop: "chargeAutomappingFlag", disable: true, descrption: "The Automapping configuration enables the activation of automapping for charge code to GCN relationships. When an NDC within the GCN family is invoiced, either via EDI 810 or through a manual purchase, the mapping will be automatically updated to reflect the newly purchased NDC, with the effective date set as one day following the invoice date" },
          {
            name: "Automapping Default", prop: "chargeGCNMapFlag", disable: true, descrption: `The Automapping Default setting determines whether automapping is enabled or disabled by default for all charge code to GCN relationships.
           When enabled (On): Every charge code to GCN relationship is set to have automapping enabled by default.
          When disabled (Off): All charge code to GCN relationships will have automapping disabled by default.`},

          { name: "Payor Exclusion ", prop: "payorExclusionFlag", disable: false, descrption: 'When the Payor Exclusions Configuration is turned on, the system will check for configured payor exclusions. Drug utilizations for excluded payors will not be considered as 340B eligible.' },
          { name: "NDC to NDC Map", prop: "ndcAsCDMFlag", disable: false, descrption: "This configuration determines how we load crosswalk templates." },
          { name: "GPO Prohibition ", prop: "gpoProhibitionFlag", disable: false, descrption: "This configuration notes if the entity is subject to the GPO Prohibition." },
          // { name: "Orphan Drug Exclusion Flag", prop: "orphanDrugExclusionFlag",disable:false },
          { name: "HRSA Medicaid Billing", prop: "carveInFlag", disable: false, descrption: "This configuration notes if the entity is Carve In or Carve Out." },
          { name: "Split Optimizer", prop: "lowestPriceCheckFlag", disable: true, descrption: "The Split Optimizer looks at both accumulations and pricing to determine which account the NDC should split to. When this feature is enabled, the standard configuration will favor WAC in an equal to situation. NDCs will split to the account with available accumulations and equal or cheaper prices (e.g., if the WAC price is equal to or less than the 340B price, the NDC will split to WAC)." },
          // { name: "Inactive Flag", prop: "inactiveFlag",disable:false },
          // { name: "ABC Accumulation API Flag", prop: "abcAccumulationAPIFlag",disable:false },
          { name: "Split Optimizer: Favors GPO", prop: "accumulateToGPO", disable: data.lowestPriceCheckFlag == "N" ? false : true, descrption: "When Split Optimizer is turned on, enabling this option will favor GPO (when accumulations are available) when the GPO and WAC prices are the same." },
          { name: "HL7 Patient Type and Location", prop: "hL7PatientAndLocationFlag", disable: true, descrption: "When this configuration is On, HL7/ADT data will be used to determine the patient type and location while processing drug utilizations." },
          { name: "HL7 Payor Update", prop: "hL7PayorFlag", disable: true, descrption: "When the HL7 Payor Update configuration is turned on, HL7 data will be used to update the account type for historical drug utilizations based on date of service and visit details." },

        ];

        flagProperties.forEach(({ name, prop, disable, descrption }) => {
          console.log(prop, name, "in foreach")
          flagsvalue.push({
            name: name,
            flag: data[prop],
            modifiedby: data.modifiedByID,
            date: data.modifiedDate,
            key: prop,
            disable: disable,
            descrption: descrption
          });
        });
        setFlags(flagsvalue)
        setLoading(false)

      }

      else {
        setLoading(false)
      }

      // setLoading(false);
    } catch (error) {
      setLoading(false);
    }
   }
    // }
    // setLoading(false);
  };
  const handelGeneralListUpdate = async (hasbool) => {
    debugger;
    let payload = {}


    payload.AccumulatorID = tabledata.accumulatorID;
    payload.LowestPriceCheckFlag = tabledata.lowestPriceCheckFlag;
    payload.ChargeAutomappingFlag = tabledata.chargeAutomappingFlag;
    payload.AccumulateToGPO = tabledata.lowestPriceCheckFlag == "N" ? "N" : tabledata.accumulateToGPO;
    payload.HL7PatientAndLocationFlag = tabledata.hL7PatientAndLocationFlag;
    payload.HL7PayorFlag = tabledata.hL7PayorFlag;
    payload.ChargeGCNMapFlag = tabledata.chargeGCNMapFlag;
    setSaveDisabled(true)
    try {
      if (hasbool === 'true') {
        handelToggle()
      }

      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Configuration/EditAccumulaterflags/${isCheck}`, payload,
        {
          hasDefaultURL: true,
        }
      );

      if (data) {
        toast.success("Updated Successfully")

        handelGeneralList()
        setEdit(false)
        setSaveDisabled(false);



      }
      // setLoading(false);
    } catch (error) {
      setSaveDisabled(false)
    }
  };




  const handelEditFlag = () => {

    setEdit(true)
  }

  const handelEditCancel = () => {
    //setIsOpenFlag(!isOpenFlag)
    setCancel(true)
    setEdit(false)
    handelGeneralList()

  }
  const toggleopenDrawer = () => {
    setOpenDrawer((pre) => !pre);
    setyperLinkFlag(false);
    //  setyperLinkFlag(link);
    //setRowData(rowData)
  };
  const toggleopenDrawerHyperLink = () => {
    setOpenDrawer(!opendrawer);
    setyperLinkFlag(true);
    //setRowData(rowData)
  };
  const toggleopenDrawerPayor = () => {
    setHl7Payordrawer((pre) => !pre);
    setHl7PayorHyperLinkFlag(false);
    //  setyperLinkFlag(link);
    //setRowData(rowData)
  };
  const toggleopenDrawerHyperLinkPayor = () => {
    setHl7Payordrawer(!hl7Payordrawer);
    setHl7PayorHyperLinkFlag(true);
    //setRowData(rowData)
  };
  const handleHyperlinkFlags = (item) => {
    if (item.key === "hL7PatientAndLocationFlag" && item.flag == "Y") {

      return <span className="text-decoration-underline " onClick={toggleopenDrawerHyperLink} >{item?.name}</span>
    }
    else if (item.key === "hL7PayorFlag" && item.flag == "Y") {
      return <span className="text-decoration-underline " onClick={toggleopenDrawerHyperLinkPayor} >{item?.name}</span>

    }
    else {
      return (

        item?.name
      )

    }


  }

  const handleSwitch = (e, item,) => {
    console.log(e, "e", item)
    debugger;
    // console.log(item, "item");
    const checked = e.target.checked;
    // if(item.key="hL7PatientAndLocationFlag" && e.target.checked==true){
    //  // handleHL7message();
    //   toggleopenDrawer()
    // }
    if (item.key === "hL7PatientAndLocationFlag" && checked) {
      setOpenDrawer(!opendrawer);
      setyperLinkFlag(false);
    }
    if (item.key === "hL7PayorFlag" && checked) {
      setHl7Payordrawer(!hl7Payordrawer);
      setHl7PayorHyperLinkFlag(false);
    }
    item.flag = checked == true ? "Y" : "N";
    if ((item.key === "lowestPriceCheckFlag" && item.flag === "N") || (item.key === "chargeAutomappingFlag")) {
      // let shg = cloneDeep(tabledata);
      // shg.accumulateToGPO==="N"
      if (flags[5].flag == "N") {
        Accumulaterflag = true;

      }

      // flags.forEach((data)=>{
      //   console.log(data,"data")
      //   if(item.key=="lowestPriceCheckFlag" && item.flag=="N"){
      //   flags[6].flag=="N"
      // }

      // })
      setFlags(prevFlags => {
        return prevFlags.map(flagItem => {
          if (flagItem.key === "accumulateToGPO" && item.key != "chargeAutomappingFlag") {
            return {
              ...flagItem,
              flag: "N"
            };
          }
          return flagItem;
        });
      })
      if (item.key === "chargeAutomappingFlag" && item.flag == "Y") {
        handelToggle()
      }
      setCheckedname("");

    }
    else {
      Accumulaterflag = false;
      if (checked) {
        if (item.key === "lowestPriceCheckFlag" && item.flag === "Y") {
          setFlags(prevFlags => {
            return prevFlags.map(flagItem => {
              if (flagItem.key === "accumulateToGPO") {
                return {
                  ...flagItem,
                  disable: true
                };
              }
              return flagItem;
            });
          })
        }
        else {
          item.flag = checked == true ? "Y" : "N";
          setCheckedname(item.name);
        }
      } else {
        setCheckedname("");
      }

    }


    const updatedTabledata = { ...tabledata };
    if (updatedTabledata.hasOwnProperty(item.key)) {
      updatedTabledata[item.key] = item.flag;
    }
    console.log(updatedTabledata, "table");
    setTableData(updatedTabledata);

    setFlags(prevFlags => {
      return prevFlags.map(flagItem =>
        flagItem.key === item.key ? { ...flagItem, flag: item.flag } : flagItem
      );
    });
  };
  const handelToggle = () => {
    setIsCheck(false)
    setIsOpen(!isOpen)

  }
  const handelChecked = () => {
    setIsCheck(!isCheck)
  }
  console.log(flags, "flags");
  return (
    <div>
      <Row>
        <div className="d-flex justify-content-between">
          <h6 className=" fw-bold text-primary mt-3 py-1 w-100 ">
            Accumulator Configurations
          </h6>
          <Col md="auto" className="">
            {edit == false &&
              <Button
                // hidden={isAddPermission}
                // disabled={isSubmitting}
                color="primary"
                className="search"
                hidden={!hasPermission("ED")}
                onClick={() => handelEditFlag()}
              // disabled={!coveredEntityid}
              // hidden={!hasPermission("ADD")}
              >
                <span className="right_5">
                  <img src={reseticon} alt="" />
                </span>{" "}
                Edit
              </Button>
            }
            {edit == true && <Button
              // hidden={isAddPermission}
              // disabled={isSubmitting}
              color="primary"
              className="search"
              hidden={!hasPermission("ED")}
              onClick={() => handelGeneralListUpdate('false')}
              disabled={savedisabled}
            // hidden={!hasPermission("ADD")}
            >
              <span className="right_5">
                <img src={save} alt="" />
              </span>{" "}
              Save
            </Button>
            }
            {edit == true && <Button
              // hidden={isAddPermission}
              // disabled={isSubmitting}
              color="primary"
              className="reset"
              hidden={!hasPermission("ED")}
              onClick={handelEditCancel}
            // onClick={() => handleReset(props)}
            // disabled={!coveredEntityid}
            // hidden={!hasPermission("ADD")}
            >
              <span className="right_5">
                <img src={CancelIcon} alt="" />
              </span>{" "}
              Cancel
            </Button>}

          </Col>
        </div>
      </Row>
      <div className="table-card scroll-table position-relative border-0 rounded pt-0 mt-2">
        <div className="rounded-table">

          <div className="table-responsive">
            <table
              style={{ zIndex: "1" }}
              id="reactstrap-table"
              className="table table-striped theme-table undefined table"
            >
              <thead>
                <tr>
                  <th width="120">Options</th>
                  <th width="140">Entity Rules</th>
                  <th width="500">Description</th>
                  <th width="180">Modified By</th>
                  <th width="120">Modified Date</th>
                </tr>
              </thead>
              {/* {ceInclusionData
                          .filter(
                            (item) => item.ruleGroupId == rule.ruleGroupId
                          )
                          .map((item) => {
                            return (
                            
                            );
                          })} */}
              <tbody >
                {/* <tr>
                                  <td className="">
                                  <FormGroup switch>
                                      <Input
                                        type="switch"
                                        role="switch"
                                        className="f-18 m-auto"
                                        style={{ margin: "auto" }}
                                        disabled={""}
                                        checked={true}
                                        // onChange={(e) => handleSwitch(e, item)}
                                      />
                                    </FormGroup>
                                    {hasPermission('ENTREDT') ? (
                                        <FormGroup switch>
                                      <Input
                                        type="switch"
                                        role="switch"
                                        className="f-20 m-auto"
                                        style={{ margin: "auto" }}
                                        disabled={item.disabled}
                                        checked={item.checked}
                                        // onChange={(e) => handleSwitch(e, item)}
                                      />
                                    </FormGroup>
                                    ) : 
                                    <FormGroup switch>
                                      <Input
                                        type="switch"
                                        role="switch"
                                        style={{ margin: "auto" }}
                                        disabled={true}
                                        checked={true}
                                      // onChange={(e) => handleSwitch(e, item)}
                                      />
                                    </FormGroup>}
                                  </td>
                                  <td className="">{"Name"}</td>
                                  <td>{"Description"}</td>
                                  <td>{"25-03-2025"}</td>
                                  <td>{"Name"}</td>
                                </tr> */}
                {flags.map((item, index) => (
                  <tr key={index} className={edit == false && !rowFlags.includes(item.key) ? 'disabled-tr' : ''}>
                    <td className={edit == false ? 'disabled-tr' : ''} >

                      <FormGroup switch>
                        <Input

                          type="switch"
                          role="switch"
                          className="f-14 m-auto"
                          style={{ margin: "auto" }}
                          disabled={item.disable == false || (Accumulaterflag == true && item.name == 'Split Optimizer: Favors GPO') || (item.lowestPriceCheckFlag === 'N' && item.name == 'Split Optimizer: Favors GPO')
                            // && tabledata.lowestPriceCheckFlag==="N"
                          }
                          // value={checkedname}
                          checked={item.flag === "Y" ? true : false}
                          onChange={(e) => handleSwitch(e, item)}
                        />
                      </FormGroup>
                    </td>
                    <td className="">{handleHyperlinkFlags(item)}</td>
                    <td>{item?.descrption}<p hidden={!(item.name == 'Automapping Default')} > <strong>Note : </strong> <span style={{fontWeight:"bold"}}>This applies to newly added relationships only, already existing will not be updated</span></p></td>
                    <td>{item.modifiedby}</td>
                    <td>{dateFormate(item.date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <Modal isOpen={isOpenFlag} toggle={handelEditCancel}>
          <ModalHeader toggle={handelEditCancel}>
            <h5 className="f-15 text-primary font-weight-700 mt-2">
              Add Comment
            </h5>
          </ModalHeader>
          <ModalBody>
            <Input type="text" name='message' onChange={(e)=>{
              setMessage(e.target.value)
            }} />
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              //disabled={addDisabled}
              className="search"
              onClick={handelGeneralListUpdate}
              //disabled={saveflag}
            >
              <span className="right_5">
                <img src={save} alt="" />
              </span>{" "}
              Save
            </Button>{" "}
            <Button color="primary" onClick={handelEditCancel} className="reset">
              <span className="right_5">
                <img src={cancel} alt="" />
              </span>{" "}
              Cancel
            </Button>
          </ModalFooter>
        </Modal> */}
      <Drawer
        direction="end"
        title="HL7 Message and Event Types for Patient and Location "
        isOpen={opendrawer}
        toggle={toggleopenDrawer}
        size="lg"
      >
        <HL7Drawer
          // hiddenCard={true}
          rowData={rowData}
          orgId={orgId}
          SelectedAccumulator={SelectedAccumulator}
          setyperLinkFlag={setyperLinkFlag}
          // tenantID={tenantID}
          hyperLinkFlag={hyperLinkFlag}
          toggleopenDrawer={toggleopenDrawer}
        />
      </Drawer>
      <Modal
        isOpen={isOpen}
        toggle={handelToggle}
        size="lg"
        className="md"
      >
        <ModalHeader toggle={handelToggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            GCN AutoMapping
          </h5>
        </ModalHeader>
        <ModalBody className="m-2 p-2">
          <div>
            {/* <p className="f-13 text-primary font-weight-600 mt-2">
                          </p> */}
            <div className="d-flex justify-content-between" >
              <Input type="checkbox" value={isCheck} onClick={handelChecked} />
              &nbsp;&nbsp;
              <p className="f-13 font-weight-600">Select the checkbox to add missing charge code to GCN relationships to the automapping table. Relationships will be added with the status defined in the Automapping Default configuration.</p>
            </div>

          </div>

        </ModalBody>
        <ModalFooter>
          {/* <Button color="primary"style={{width:"90px"}}  onClick={handelGeneralListUpdate} >
                            Apply & Save
                          </Button>{" "} */}
          <Button color="primary" style={{ width: "160px" }} className="search" onClick={() => handelGeneralListUpdate('true')} >
            <span className="right_5">
              <img src={save} alt="" />
            </span>{" "}  Apply & Save
          </Button>{" "}

        </ModalFooter>
      </Modal>
      <Drawer
        direction="end"
        title="HL7 Message and Event Types for Payor Updates"
        isOpen={hl7Payordrawer}
        toggle={toggleopenDrawerPayor}
        size="lg"
      >
        <Hl7Payor
          // hiddenCard={true}
          rowData={rowData}
          orgId={orgId}
          SelectedAccumulator={SelectedAccumulator}
          setHl7PayorHyperLinkFlag={setHl7PayorHyperLinkFlag}
          // tenantID={tenantID}
          hl7PayorhyperLinkFlag={hl7PayorhyperLinkFlag}
          toggleopenDrawerPayor={toggleopenDrawerPayor}
        />
      </Drawer>
    </div>

  );
};

export default General;
